import { render, staticRenderFns } from "./AllRetailerDeleted.vue?vue&type=template&id=f2e97c8a&scoped=true"
import script from "./AllRetailerDeleted.vue?vue&type=script&lang=js"
export * from "./AllRetailerDeleted.vue?vue&type=script&lang=js"
import style0 from "./AllRetailerDeleted.vue?vue&type=style&index=0&id=f2e97c8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e97c8a",
  null
  
)

export default component.exports